import React from "react";
import "./Footer.css";

const Footer = () => {
	const currentYear = new Date().getFullYear();

	const footerLinks = [
		{
			title: "TriviaRat",
			links: [
				{ label: "Host Login", url: "https://triviarat.com/sign-in" },
				{ label: "TriviaRat Home", url: "https://triviarat.com/" },
				{ label: "Venues", url: "https://triviarat.com/venue-sign-up" },
				{ label: "Support", url: "https://triviarat.com/contact-us" },
			],
		},
		{
			title: "Other Products",
			links: [
				{ label: "Eternal Trivia (Live)", url: "https://eternaltrivia.com?utm_source=enterprisetriviarat" },
				{ label: "Bracket Force", url: "https://bracketforce.com?utm_source=enterprisetriviarat" },
				{ label: "ElectoSense", url: "https://electosense.com?utm_source=enterprisetriviarat" },
			],
		},
	];

	return (
		<footer className="enterprise-footer">
			<div className="footer-content">
				<div className="footer-grid">
					<div className="footer-brand">
						<h3>TriviaRat Enterprise</h3>
						<p>Centralized command for your trivia empire. Manage multiple hosts, configure settings, and grow your business.</p>
					</div>
					
					{footerLinks.map((section, index) => (
						<div key={index} className="footer-section">
							<h4>{section.title}</h4>
							<ul>
								{section.links.map((link, linkIndex) => (
									<li key={linkIndex}>
										<a href={link.url} target="_blank" rel="noopener noreferrer">
											{link.label}
										</a>
									</li>
								))}
							</ul>
						</div>
					))}
				</div>
				
				<div className="footer-bottom">
					<p>&copy; {currentYear} TriviaRat Enterprise. All rights reserved.</p>
				</div>
			</div>
		</footer>
	);
};

export default Footer;
